import React, { PureComponent } from 'react';

class ProgressBar extends PureComponent {
  render() {
    const { scale, value, avg } = this.props;

    return (
      <div className="progress">
        <div className="progress__bar">
          <div className="progress__barinner" style={{ width: `${scale(value)}%` }} />
        </div>
        <div className="progress__avg" style={{ left: `${scale(avg)}%` }}>
          <div className="progress__avg-sign">ø</div>
          <div className="progress__avg-line" />
        </div>
      </div>
    );
  }
}

export default ProgressBar;
